<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_MAPPED_LOCATION</h6>
    </div>
    <div class="modal-body">
            <!--<div class="row mb-2">
                <div class="col">
                    <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" name="Keyword" [(ngModel)]="Keyword" (input)="onKeyword($event.target.value)">
                </div>
            </div>-->
        <div class="grdTable">
            <div class="grdBodyScroll-Virtual" #scrollingBlock>
                <virtual-scroller #scroll [items]="SectionLocations" style="height:100%" [parentScroll]="scrollingBlock.nativeElement">
                    <div *ngFor="let row of scroll.viewPortItems" class="row no-gutters grdRow">
                        <div class="col form-check">
                            <label class="form-check-label">
                                {{row.LocationDescription}}
                            </label>
                        </div>
                    </div>
                </virtual-scroller>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" (click)="d('dismiss')" translate>BTN.BTN_OK</button>        
    </div>
</ng-template>
